import { getCookie } from '../components/common/cookie'

export const isWechat = () =>
  getCookie('padiWxId')?.length === 28 || window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > 0

export const isUnionId = (id) => id?.length === 28

// 微信登录态 cookie padiWxId 即 openid（28 位）。富友支付 openid 必传（后端不从 session 解析），
// 微信内取该值透传；非微信环境（PC 扫码等）无 28 位登录态则返回 undefined。
// 调用方无需自行过滤：POST 由 JSON.stringify 自动丢弃，GET 由服务层序列化时统一过滤
// （见 services/hooks.js fetchWrapper、services/api.js fetchJwtWrapper）
export const getWechatOpenId = () => {
  const padiWxId = getCookie('padiWxId')
  return isUnionId(padiWxId) ? padiWxId : undefined
}
